"use client";

import { useTranslation } from "react-i18next";
import Button from "@/components/library/Button";
import Icon from "@/components/library/Icon";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export type MissingVoiceDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onChooseVoice?: () => void;
};

export default function MissingVoiceDialog({
  open,
  onOpenChange,
  onChooseVoice,
}: Readonly<MissingVoiceDialogProps>) {
  const { t } = useTranslation("inbound");

  return (
    <Dialog open={open} onOpenChange={onOpenChange} blurBackdrop>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Icon icon="triangle-exclamation" className="w-5 h-5 text-primary" />
            {t("pages.agent.voiceUnavailableTitle")}
          </DialogTitle>
          <DialogDescription>
            {t("pages.agent.voiceUnavailableBody")}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex gap-2 pt-2">
          <Button
            type="primary"
            compact
            onClick={() => {
              onChooseVoice?.();
              onOpenChange(false);
            }}
          >
            {t("pages.agent.voiceUnavailableChoose")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
